import classnames from 'classnames';
import React from 'react';

interface FrameProps {
	children: React.ReactNode;
	className?: string;
	dataqa?: string;
}

const Frame: React.FC<FrameProps> = ({ children, className, dataqa }) => {
	return (
		<div
			className={classnames('common-ui-panel-frame', className)}
			data-qa={dataqa}
		>
			{children}
		</div>
	);
};

export default Frame;
